import { render, staticRenderFns } from "./EngineeringDetailed.vue?vue&type=template&id=39fac7e8&scoped=true&"
import script from "./EngineeringDetailed.vue?vue&type=script&lang=js&"
export * from "./EngineeringDetailed.vue?vue&type=script&lang=js&"
import style0 from "./EngineeringDetailed.vue?vue&type=style&index=0&id=39fac7e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fac7e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
